export default __webpack_public_path__ + "static/media/raseet-bw-logo.8a94fc2c.png";